import { configureStore } from "@reduxjs/toolkit";
import LayoutSlice from "./reducers/LayoutSlice";
import BookmarkHeaderSlice from "./reducers/BookmarkHeaderSlice";
import ThemeCustomizerSlice from "./reducers/ThemeCustomizerSlice";
import OrganizationSlice from "./reducers/OrganizationSlice";
import ProjectSlice from "./reducers/ProjectSlice";
import FilterSlice from "./reducers/FilterSlice"

const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    bookmarkHeader: BookmarkHeaderSlice,
    themeCustomizer: ThemeCustomizerSlice,
    product: OrganizationSlice,
    project: ProjectSlice,
    filterData: FilterSlice,
  },
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
